import { Control, FieldPath, FieldValues } from 'react-hook-form'
import z from 'zod'

export type TransferListItem = {
  creamBackground?: boolean
  label: string
  value: string
}

export const transferListSchema = z.object({
  left: z.array(z.string()),
  right: z.array(z.string()),
})

export type TransferListConatinerProps<T extends FieldValues> = Pick<
  TransferListProps,
  'all' | 'disabled'
> & {
  control: Control<T>
  name: FieldPath<T>
}

export type TransferListProps = {
  all: TransferListItem[]
  disabled?: boolean
  onChange: (value: TransferListSchema) => void
  value: TransferListSchema
}

export type TransferListSchema = z.infer<typeof transferListSchema>
